<template>
  <div id="app">
    <!-- <daohang> </daohang> -->

    <router-view></router-view>
    <!-- <dibudaohang> </dibudaohang> -->
  </div>
</template>

<script>
// import daohang from "./components/index/daohang.vue";
// import dibudaohang from "./components/dibudaohang/dibudaohang";

export default {
  name: "App",
  components: {
    // daohang,
    // dibudaohang
  },
};
</script>

<style>
body {
  margin: 0;
  overflow-x: hidden;
}
</style>
